import { render, staticRenderFns } from "./Field-setup.vue?vue&type=template&id=7d8be141&scoped=true"
import script from "./Field-setup.vue?vue&type=script&lang=js"
export * from "./Field-setup.vue?vue&type=script&lang=js"
import style0 from "./Field-setup.vue?vue&type=style&index=0&id=7d8be141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8be141",
  null
  
)

export default component.exports